<template>
  <div v-if="item?.employee?.email">
    {{ item?.employee?.email }}
  </div>
  <div v-else>
    {{ item?.email }}
  </div>
</template>
<script>
export default {
  props: ["item"],
};
</script>
